<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10">
      <v-col class="pt-0">
        <span class="text-tcdc-green bold header text-uppercase">{{$t('serviceArea.visitServiceArea')}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="text-tcdc-green bold header text-uppercase">{{$t('serviceArea.groupVisit')}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10">
        <p class="vhtml" v-html="groupVisit[`description_${lang}`]"></p>
      </v-col>
    </v-row>
    <v-row class="mb-12">
      <v-col cols="12" md="10">
        <p class="vhtml" v-html="groupVisit[`detail_${lang}`]"></p>
        <!--        <v-row>-->
<!--          <template v-for="(item, index) of 3">-->
<!--            <v-col :key="index.toString()" cols="12" md="4">-->
<!--              <div class="d-flex flex-1 flex-column">-->
<!--                <div class="d-flex flex-1 align-center mb-7">-->
<!--                  <div class="text-center mr-6 tcdc-ball-green d-flex align-center justify-center">-->
<!--                    <span class="white&#45;&#45;text bold">{{index + 1}}</span>-->
<!--                  </div>-->
<!--                  <span class="text-tcdc-green sub-header2 bold">Request form</span>-->
<!--                </div>-->
<!--                <div class="d-flex flex-1">-->
<!--                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam-->
<!--                  nonummy nibh euis- mod tincidunt ut laoreet dolore magna aliquam-->
<!--                  erat.-->
<!--                </div>-->
<!--              </div>-->
<!--            </v-col>-->
<!--          </template>-->
<!--        </v-row>-->
      </v-col>
    </v-row>
<!--    <v-row>-->
<!--      <v-col>-->
<!--        <div class="d-flex flex-1 align-center">-->
<!--          <img src="../../assets/icons/group-visit/letter.png" class="tcdc-letter-logo mr-3" />-->
<!--          <span class="text-tcdc-green bold text-uppercase sub-header1">{{$t('visitForm.request')}}</span>-->
<!--        </div>-->
<!--        <div class="pt-5" v-if="groupVisit.contact_info">-->
<!--&lt;!&ndash;          <div class="vhtml" v-html="groupVisit.contact_email"></div>&ndash;&gt;-->
<!--          <div class="vhtml" v-html="groupVisit.contact_info"></div>-->
<!--        </div>-->
<!--      </v-col>-->
<!--    </v-row>-->
<!--    <v-row>-->
<!--      <v-col>-->
<!--        <VisitGroupForm class="vhtml" :remark="groupVisit[`message_${lang}`]" @onSubmit="sendMsg" />-->
<!--        <AlertModal-->
<!--                :show="modal"-->
<!--                :message="modalMsg"-->
<!--                @onConfirm="modal = false"-->
<!--        ></AlertModal>-->
<!--      </v-col>-->
<!--    </v-row>-->
  </v-container>
</template>

<script>
// import GreenButton from "../../components/buttons/GreenButton";
import AlertModal from "../../components/modals/AlertModal";
import VisitGroupForm from "../../components/form/VisitGroupForm";
import { mapState } from "vuex";
import {BreadcrumbUtil} from "../../util/BreadcrumbUtil";

export default {
  components: {
    // GreenButton,
    // VisitGroupForm,
    // AlertModal
  },
  methods: {
    submitHandler() {
      // console.log("submit form...");
    },
    sendMsg(form) {
      form.branch_id = this.branch_id;
      if (form.email && form.phone && form.organization_name) {
        this.$store.dispatch('Contact/sendMsgGroupVisit', form).then(() => {
          this.modalMsg = this.$t('messageBox.success');
          this.modal = true;
        });
      } else {
        this.modalMsg = this.$t('messageBox.notValid');
        this.modal = true;
      }
    }
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
            this.items,
            this.branch_id,
            this.branchName,
            this.allBranches,
            this.lang
    )
    if (this.$route.params.branch) {
      let params = { branch_id: 0, lang: this.lang };
      for (const b of this.allBranches) {
        if (this.$route.params.branch === b.tag_name) {
          if (!this.$route.params.branch) {
            await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
            break;
          }
          params.branch_id = b.branch_id;
          if (this.$route.params.branch === 'mini-tcdc') {
            await this.$store.dispatch('Branch/getMiniByBranch', params);
            break;
          }
          await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
          await this.$store.dispatch("Branch/getBranchById", params.branch_id);
          break;
        }
      }
    } else {
      if (this.branch_id !== 0) {
        let params = { branch_id: 0, lang: this.lang };
        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
        await this.$store.dispatch("Branch/getBranchById", params.branch_id);
      }
    }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      groupVisit: state => state.ServiceMenu.group_visit,
      lang: state => state.Branch.lang,
      branch_id: state => state.Branch.branch_id
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
              this.items,
              this.branch_id,
              this.branchName,
              this.allBranches,
              this.lang
      )
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home/tcdc-bangkok"
      },
      {
        text: "SERVICE",
        to: "/:branch/service",
      },
      {
        text: "VISIT & SERVICE AREA",
        to: "/:branch/service/visit-and-service-area",
      },
      {
        text: "GROUP VISIT",
        disabled: true
      }
    ],
    modal: false,
    modalMsg: ''
  })
};
</script>

<style>
.tcdc-ball-green {
  width: 30px;
  height: 30px;
  background-color: green;
  border-radius: 100px;
}
.tcdc-letter-logo {
  height: 25px;
  object-fit: contain;
}
</style>
